<template>
  <footer class="app-footer-container">
    <p>
      spready.net copyright all reserved.
    </p>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style>
.app-footer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8rem;
  color: #484848;
  background: black;
  padding-top: 20px;
  font-family: sans-serif;
}
p {
  font-size: 0.7rem;
}

.space {
  border-left: 1px solid #484848;
  height: 15px;
  margin-left: 10px;
  margin-right: 10px;
  width: 1px;
}
</style>
